import React from "react";
import WidgetCard from "./WidgetCard";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { COLORS } from "@ts/constants";
import { IPriceVsSalesData, PricingCharts } from "@ts/common-types";
import { Row, Col } from "antd";

const PriceVsSalesWidget: React.FC<IPriceVsSalesData> = ({
    title,
    widgetData,
    additionalTitleComponent,
    currencySymbol
}) => {
    const getChartConfig = () => {
        const seriesData = widgetData.map((item) => [item.price, item.sales]);

        return {
            chart: {
                type: "scatter",
                zoomType: "xy",
                responsive: true,
            },
            title: {
                text: "",
            },
            xAxis: {
                title: {
                    enabled: true,
                    text: `Price (${currencySymbol})`,
                }
            },
            yAxis: {
                title: {
                    text: "Sales (Units)",
                },
            },
            tooltip: {
                pointFormat:
                    "Price: <b>{point.x}</b><br>Units sold: <b>{point.y}</b>",
            },
            credits: {
                enabled: false,
            },
            colors: COLORS,
            series: [
                {
                    name: "Product Data",
                    color: "blue",
                    data: seriesData,
                },
            ],
            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: 500,
                        },
                        chartOptions: {
                            legend: {
                                align: "center",
                                verticalAlign: "bottom",
                                layout: "horizontal",
                            },
                        },
                    },
                ],
            },
        };
    };

    return (
        <WidgetCard className="my-4">
            <Row className="fs-5 mb-5">
                <Col span={additionalTitleComponent ? 21 : 24}>
                    <h5>{title || "Price Vs Sales"}</h5>
                </Col>
                {additionalTitleComponent && (
                    <Col span={3}>{additionalTitleComponent(PricingCharts.PRICE_SALES_PPU)}</Col>
                )}
            </Row>
            <HighchartsReact
                highcharts={Highcharts}
                options={getChartConfig()}
            />
        </WidgetCard>
    );
};

export default PriceVsSalesWidget;